<template>
  <div class="form-category">
    <div>
      <v-btn class="btn-add-category" :aria-label="$t('Ключевые слова')" @click.native.stop="catdialog = true">
        <span class="pro-icon-add" aria-hidden="true"></span>
      </v-btn>
      <v-dialog v-model="catdialog" max-width="600">
        <v-card class="modal">
          <div class="modal-head">
            {{ $t("Ключевые слова") }}
            <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="catdialog = false">
              <span class="pro-icon-close1" aria-hidden="true"></span>
            </v-btn>
          </div>
          <div class="modal-body">
            <v-text-field
              v-model="search"
              :label="$t('Ключевые слова')"
              dense
              clearable
              outlined
            ></v-text-field>
            <v-treeview
              v-model="selectedKeywords"
              :items="keywords"
              :search="search"
              :label="$t('Ключевые слова')"
              :selection-type="'independent'"
              return-object
            >
              <template slot="label" slot-scope="{ item }">
                <v-checkbox
                  v-model="selectedCheckbox[item.id]"
                  @change="setKeyword($event, item)"
                  :label="item.name"
                  hide-details>
                </v-checkbox>
              </template>
            </v-treeview>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <div class="tags">
      <span class="tag" v-for="item in selectedKeywords" :key="item.id">
        {{ item.name }}
        <span
          class="pro-icon-close"
          role="button"
          tabindex="0"
          :aria-label="$t('Удалить') + ': ' + item.name"
          @click="deleteTag(item.id)"
          @keyup.enter="deleteTag(item.id)"
          @keyup.space="deleteTag(item.id)"
        ></span>
      </span>
    </div>
  </div>
</template>

<script>
import GET from '@/store/modules/getNpaData'

export default {
  props: {
    datanpa: Object
  },
  data: () => ({
    keywords: [],
    selectedKeywords: [],
    catdialog: false,
    selectedCheckbox: [],
    search: ''
  }),
  mounted() {
    GET.getNpaData()
      .then((response) => {
        this.keywords = response.data.refKeyword
      })
      .catch((error) => {})
  },
  methods: {
    changeKeywords() {
      const keywordId = this.selectedKeywords.map((item) => item.id)
      this.keywords.forEach((element, index) => {
        if (keywordId.includes(element.id)) {
          this.selectedCheckbox[element.id] = true
        } else {
          this.selectedCheckbox[element.id] = false
        }
      })
      this.$emit('changeKeywords', keywordId)
    },
    setKeyword(status, keyword) {
      if (status === true) {
        this.selectedKeywords.push(keyword)
      } else {
        this.selectedKeywords.filter(
          (item) => Number(item.id) !== Number(keyword.id)
        )
      }
      this.changeKeywords()
    },
    deleteTag(id) {
      this.selectedKeywords = this.selectedKeywords.filter(
        (item) => Number(item.id) !== Number(id)
      )
      this.changeKeywords()
    }
  }
}
</script>
